import { useMemo, useRef } from 'react';
import type { PropsWithChildren } from 'react';
import { InteractionContext } from './InteractionContextInstance';

export function InteractionProvider({ children }: PropsWithChildren) {
  const boardRef = useRef<HTMLDivElement>(null);
  const trashRef = useRef<HTMLDivElement>(null);
  const value = useMemo(() => ({ boardRef, trashRef }), []);
  return <InteractionContext.Provider value={value}>{children}</InteractionContext.Provider>;
}
